import {customLog} from "./../../customLog.js";
export const addFetching ="ADD_FETCHING";
export const removeFetching = "REMOVE_FETCHING";

export const modal_editList_replaceComp = "replaceComposition";
export const modal_editList_selectComp = "selectCompositionForList";

export const modal_genericSelectFromList = "genericSelectFromList";

export const modal_search1 = "MODAL_SEARCH";

export const modal_record = "MODAL_RECORD";

export const addLogMessage = "ADD_LOG_MESSAGE";
export const addSelectedIdToLog = "ADD_SELECTED_ID_TO_LOG";
export const keepLogClean = "KEEP_LOG_CLEAN";

export const showSelectModalConst = "SHOW_SELECT_MODAL";
export const removeSelectModalConst = "SELECTED_OBJECT_IN_MODAL";

export const tempData ="TEMP_DATA";
export const setAudioAvailability = "AUDIO_AVAILABILITY";
export const clearAudioAvailability = "CLEAR_AUDIO_AVAILABILITY";
export const animation ="ANIMATION";

export const availabilityState_downloading = "DOWNLOADING";
export const availabilityState_inDocumentsDir = "IN_DOCUMENTS_DIR";
export const availabilityState_CheckingDir = "CHECKING_DIR";
export const availabilityState_Error = "ERROR";

export const k_setGeoLocationData = "SET_GEOLOCATION_DATA";

export const k_setSetShowLog = "SET_SHOW_LOG";

export const k_clearAllState = "CLEAR_ALL_STATE";

export function setFetching(fetchKey)
{
	//customLog("Setting fetching");
	return {
		type: addFetching,
		payload: {key:fetchKey}
	};
}

export function setDoneFetching(fetchKey)
{
	return {
		type: removeFetching,
		payload: {key:fetchKey}
	};
}

export const push = "PUSH";
export const pop = "POP";
export const clear = "CLEAR";


export function pushSearchModal1(searchContext)
{
	customLog("Pushing Search modal with searchContext: " + searchContext);

	const modalProps = {searchContext:searchContext};
	customLog(modalProps);
	return pushModalView(modal_search1, modalProps);
}

export function pushReplaceCompInList(compId)
{
	const modalProps = {compId:compId};
	return pushModalView(modal_editList_replaceComp, modalProps);
}

export function pushModalRecord(trackNr)
{
	const modalProps = {trackNr:trackNr};
	return pushModalView(modal_record, modalProps);
}

export function pushModalIncludeComp(compId)
{
	const modalProps = {compId:compId};
	return pushModalView(modal_editList_selectComp, modalProps);
}

export function pushModalView(modalType, modalProps)
{
	//customLog("Pushing modal:");
	//customLog(view);
	return changeModalView(push, modalType, modalProps);
}

export function popModalView(modalType, modalProps)
{
	return changeModalView(pop, modalType, modalProps);
}


export function clearModalViews()
{
	return changeModalView(clear);
}

export function changeModalView(changeType, modalType, modalProps)
{
	return {
		type: changeType,
		payload: {modalType:modalType, modalProps:modalProps}
	};
}

export function logMessage(msg)
{
	customLog("Log message: " + msg);

	return {
		type: addLogMessage,
		payload: msg
	};
}

export function cleanLog(cleanBeforeThisTime)
{
	return {
		type:keepLogClean,
		payload:cleanBeforeThisTime,

	}
}


export function removeSelectModal(contextId)
{
	return {
		type: removeSelectModalConst,
		payload: {
			contextId: contextId,
		}
	}

}

export function showSelectModal(objectsToSelect, selectedIdsFromStart, contextId, selectAction, selectMultiple)
{
	const modalProps = {
		contextId: contextId,
		objects: objectsToSelect,
		selectedFromStart:selectedIdsFromStart,
		selectAction: selectAction,
		selectMultiple: selectMultiple,
		};

	return pushModalView(modal_genericSelectFromList, modalProps);
}


export function logSelectedId(selectedId)
{
	return {
		type:addSelectedIdToLog,
		payload:{selectedId:selectedId},
	}
}

export function setModalTempData(dataKey, data)
{
	return {
		type:tempData,
		payload: {page:"modal", dataKey:dataKey, data:data}
	}
}

export function setGeolocation(reactGeodata)
{
	return{
		type: k_setGeoLocationData,
		payload: {
			lng:reactGeodata.coords.longitude,
			lat:reactGeodata.coords.latitude,
			accuracy: reactGeodata.coords.accuracy,
			speed: reactGeodata.coords.speed,
			heading: reactGeodata.coords.heading,
			}
	}
}

export function setShowLog(show)
{
	return {
		type: k_setSetShowLog,
		payload:{show:show}
	}
}

export function clearAllState()
{
	return {
		type: k_clearAllState,
	}
}
/*
export function setAudiofileAvailable(fileName, availabilityState, progress, jobId)
{
	return {
		type: setAudioAvailability,
		payload: {
			fileName:fileName,
			availabilityState: availabilityState,
			progress:progress,
			transferId: jobId

			}
	}
}

export function clearAudioFileAvailability()
{
	return {
		type: clearAudioAvailability,
		payload: {}
	}
}
*/


// WEBPACK FOOTER //
// ./js/stateStuff/actions/globalActions.js